import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export type AppLanguage = 'cs' | 'en' | 'uk' | 'de' | 'sk';

type AppUiState = {
  isDrawerOpen: boolean;
  searchText: string;
  isSearchActive: boolean;
  searchFilter: 'clients' | 'material' | 'goods';
};

const initialState: AppUiState = {
  isDrawerOpen: false,
  isSearchActive: false,
  searchText: '',
  searchFilter: 'clients',
};

const appUiSlice = createSlice({
  name: 'appUi',
  initialState,
  reducers: {
    toggleDrawer: state => {
      state.isDrawerOpen = !state.isDrawerOpen;
    },
    setSearchState: (state, action: PayloadAction<boolean>) => {
      state.isSearchActive = action.payload;
    },
    setDrawerOpen: (state, action: PayloadAction<boolean>) => {
      state.isDrawerOpen = action.payload;
    },
    setSearchText: (state, action: PayloadAction<string>) => {
      state.searchText = action.payload;
    },
    setSearchFilter: (state, action: PayloadAction<'clients' | 'material' | 'goods'>) => {
      state.searchFilter = action.payload;
    },
  },
});

export const { toggleDrawer, setSearchState, setDrawerOpen, setSearchText, setSearchFilter } =
  appUiSlice.actions;

export default appUiSlice.reducer;
